import { ImCross } from 'react-icons/im'
import { FaChevronDown } from 'react-icons/fa'
import styles from './ModalSaveNote.module.css'
import { useEffect, useMemo, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Loader from '../../loader/Loader'
import {
  useAddClientSavedOrderMutation,
  useGetClientSavedOrderLastGroupQuery,
  useGetClientSavedOrderGroupNamesQuery,
} from '../../../redux/clientData/apiClientData'

const ModalSaveNote = ({ spare, setSpare }) => {
  const [groupName, setGroupName] = useState('')
  const [description, setDescription] = useState('')
  const [qtyInput, setQtyInput] = useState(1)
  const [isDisabledButton, setIsDisabledButton] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const groupFieldRef = useRef(null)

  const { data: lastGroup, isLoading: isLoadingLastGroup } =
    useGetClientSavedOrderLastGroupQuery()

  const { data: groupNamesData, isLoading: isLoadingGroupNames } =
    useGetClientSavedOrderGroupNamesQuery()

  const [addClientSavedOrder, { isLoading: isLoadingAdd }] =
    useAddClientSavedOrderMutation()

  useEffect(() => {
    if (lastGroup?.lastGroupName) {
      setGroupName(lastGroup.lastGroupName)
    }
  }, [lastGroup])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        groupFieldRef.current &&
        !groupFieldRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const filteredGroupNames = useMemo(() => {
    const names = groupNamesData?.groupNames || []
    const query = groupName.trim().toLowerCase()
    if (!query) return names
    return names.filter((name) => name.toLowerCase().includes(query))
  }, [groupNamesData, groupName])

  const closeModal = () => setSpare(null)

  const handleSelectGroup = (name) => {
    setGroupName(name)
    setIsDropdownOpen(false)
  }

  const handleQtyInput = (e) => {
    const value = e.target.value
    if (value === '') {
      setQtyInput('')
      return
    }
    const parsed = parseInt(value, 10)
    if (Number.isNaN(parsed) || parsed < 1) {
      setQtyInput(1)
      return
    }
    setQtyInput(parsed)
  }

  const handleSave = async () => {
    if (!groupName.trim()) {
      toast.error('Вкажіть назву групи')
      return
    }
    setIsDisabledButton(true)
    try {
      await addClientSavedOrder({
        spareID: spare.spareID,
        groupName: groupName.trim(),
        description: description.trim(),
        requiredQty: qtyInput === '' ? 1 : qtyInput,
      }).unwrap()
      toast.success('Збережено в нотатки')
      closeModal()
    } catch (error) {
      toast.error('Сталась помилка...')
      setIsDisabledButton(false)
    }
  }

  return (
    <>
      {isLoadingLastGroup && <Loader />}
      {isLoadingGroupNames && <Loader />}
      {isLoadingAdd && <Loader />}
      <div
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            closeModal()
          }
        }}
        className="overlayCont"
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className={styles.modalContainer}
        >
          <div className={styles.modalHeader}>
            <div>Зберегти в нотатки</div>
            <div onClick={closeModal} className={styles.closeIcon}>
              <ImCross />
            </div>
          </div>

          <div className={styles.orderContainer}>
            <div className={styles.infoText}>Бренд</div>
            <div className={styles.spareInfoContainer}>
              <div className={styles.infoText}>{spare.brand}</div>
            </div>
          </div>

          <div className={styles.orderContainer}>
            <div className={styles.infoText}>Артикул</div>
            <div className={styles.spareInfoContainer}>
              <div className={styles.infoText}>{spare.code}</div>
            </div>
          </div>

          <div className={styles.orderContainer}>
            <div className={styles.infoText}>Група (VIN / опис)</div>
            <div className={styles.spareInfoContainer}>
              <div className={styles.groupFieldWrapper} ref={groupFieldRef}>
                <div className={styles.groupInputRow}>
                  <input
                    className={styles.groupInput}
                    type="text"
                    value={groupName}
                    placeholder="Оберіть або введіть назву"
                    onChange={(e) => {
                      setGroupName(e.target.value)
                      setIsDropdownOpen(true)
                    }}
                    onFocus={() => setIsDropdownOpen(true)}
                  />
                  <span
                    className={styles.groupToggle}
                    onClick={() => setIsDropdownOpen((prev) => !prev)}
                  >
                    <FaChevronDown />
                  </span>
                </div>
                {isDropdownOpen && filteredGroupNames.length > 0 && (
                  <div className={styles.groupDropdown}>
                    {filteredGroupNames.map((name, i) => (
                      <div
                        key={`${name}-${i}`}
                        className={styles.groupDropdownItem}
                        onClick={() => handleSelectGroup(name)}
                      >
                        {name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={styles.orderContainer}>
            <div className={styles.infoText}>Примітка</div>
            <div className={styles.spareInfoContainer}>
              <textarea
                className={styles.textArea}
                value={description}
                placeholder="Необов'язково"
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.orderContainer}>
            <div className={styles.infoText}>Кількість</div>
            <div className={styles.spareInfoContainer}>
              <input
                className={styles.qtyInput}
                type="number"
                value={qtyInput}
                onChange={handleQtyInput}
              />
            </div>
          </div>

          <hr className={styles.modalHR} />

          <div className={styles.btnsContainer}>
            <div className={styles.infoBtnContainer}>
              <button
                onClick={handleSave}
                disabled={isDisabledButton}
                className={styles.infoBtn}
              >
                Зберегти
              </button>
            </div>
            <div className={styles.infoBtnContainer}>
              <button onClick={closeModal} className={styles.infoBtn}>
                Відмінити
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ModalSaveNote
